@if (center()?.private) {
  <section modalContainer invisibleWhitespace>
    <div class="p-4 pt-10 flex flex-col gap-6">
      <div class="flex flex-col gap-3 items-center">
        <img src="no-plan.svg" class="mb-[1rem]" />
        <p class="text-center text-gray-800 text-xl font-semibold">
          플랜 구독 후 이용 가능합니다.
        </p>
      </div>
      <p class="text-gray-600 text-sm text-center">
        해당 메뉴는 플랜 구독 후 이용 가능합니다.<br />
        구독을 원하시면 구독 페이지로 이동해주세요.
      </p>
    </div>
    <div footer class="p-4 flex gap-3 items-center">
      <app-button expand (click)="close()" variant="outline" color="white"
        >닫기</app-button
      >
      <app-button expand>구독</app-button>
    </div>
  </section>
} @else {
  <section modalContainer invisibleWhitespace>
    <div class="p-4 pt-10 flex flex-col gap-6">
      <div class="flex flex-col gap-3 items-center">
        <img src="no-permission.png" class="size-[5.375rem]" />
        <p class="text-center text-gray-800 text-xl font-semibold">
          권한이 없습니다.
        </p>
      </div>
      <p class="text-gray-600 text-sm text-center">
        해당 센터의 메뉴에 대한 권한이 없어 접근할 수 없습니다. <br />권한이
        필요하면 센터 관리자에게 문의하세요.
      </p>
    </div>
    <div footer class="p-4">
      <app-button expand (click)="close()" variant="outline" color="white"
        >확인</app-button
      >
    </div>
  </section>
}
